import { computed, Injectable, Signal } from '@angular/core';
import { ParticipantService } from '@shared/services/participant/participant.service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public storagePrefix: Signal<string> = computed((): string =>
    this.computeStoragePrefix(this.participantService.participant()?.id || 'guest'),
  );

  constructor(private participantService: ParticipantService) {}

  public getFromLocalStorage(key: string, useStoragePrefixKey: boolean = true): string | null {
    return localStorage.getItem(useStoragePrefixKey ? this.buildKeyLocalStorage(key) : key);
  }

  public removeFromLocalStorage(key: string): void {
    localStorage.removeItem(this.buildKeyLocalStorage(key));
  }

  public storeInLocalStorage(key: string, value: string, overriddenParticipantId?: number | undefined): void {
    localStorage.setItem(this.buildKeyLocalStorage(key, overriddenParticipantId), value);
  }

  private buildKeyLocalStorage(key: string, overriddenParticipantId?: number | undefined): string {
    const prefix: string = overriddenParticipantId
      ? this.computeStoragePrefix(overriddenParticipantId)
      : this.storagePrefix();
    return `${prefix}${key}`;
  }

  private computeStoragePrefix(participantId: number | string | undefined): string {
    return `pl3-${participantId}-`;
  }
}
